import React from "react";
import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";
import {
  BellRing,
  CheckCircle2,
  FileText,
  Layers,
  XCircle,
} from "lucide-react";
import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";
import { useBulkCommunicationAuditSummary } from "@features/cx/outstanding/hooks";

export const AuditTrailSummary: React.FC = () => {
  const remoteUtilityId = useRemoteUtilityId();
  const { data: auditSummary, isLoading } = useBulkCommunicationAuditSummary(
    remoteUtilityId || "",
  );

  const summaryCards = [
    {
      label: "TOTAL BATCHES",
      value: auditSummary?.totalBatches,
      icon: <Layers className="h-4 w-4 text-blue-500" />,
    },
    {
      label: "BULK NOTICES",
      value: auditSummary?.bulkNotices,
      icon: <FileText className="h-4 w-4 text-orange-500" />,
    },
    {
      label: "BULK REMINDERS",
      value: auditSummary?.bulkReminders,
      icon: <BellRing className="h-4 w-4 text-orange-500" />,
    },
    {
      label: "DELIVERED",
      value: auditSummary?.totalDelivered,
      icon: <CheckCircle2 className="h-4 w-4 text-green-500" />,
    },
    {
      label: "FAILED",
      value: auditSummary?.totalFailed,
      icon: <XCircle className="h-4 w-4 text-red-500" />,
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-6">
      {summaryCards.map((card, index) => (
        <QuickStatsCard
          key={index}
          title={card.label}
          count={card.value}
          icon={card.icon}
        />
      ))}
    </div>
  );
};

export default AuditTrailSummary;
